// extracted by mini-css-extract-plugin
export default {"content":"contact_content__CjLPx","desc":"contact_desc__ycDSf","form":"contact_form__Kly0D","content_form":"contact_content_form__Xh1y+"};